(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.ElementsReadMore) return;
    window.ElementsReadMore = true;

    const focusableSelector =
      'a[href], button, input, select, textarea, details, [tabindex]';

    function updateExpandedHeight(wrapper) {
      const clip = wrapper.querySelector(".elements-section__read-more-clip");
      if (!clip) return;
      clip.style.maxHeight = `${clip.scrollHeight}px`;
    }

    function setFocusable(clip, enabled) {
      if (!clip) return;
      clip
        .querySelectorAll(focusableSelector)
        .forEach(function (element) {
          if (enabled) {
            if (element.hasAttribute("data-read-more-tabindex")) {
              const previous = element.getAttribute("data-read-more-tabindex");
              element.removeAttribute("data-read-more-tabindex");
              if (previous === "") {
                element.removeAttribute("tabindex");
              } else {
                element.setAttribute("tabindex", previous);
              }
            }
          } else {
            if (!element.hasAttribute("data-read-more-tabindex")) {
              const previous = element.getAttribute("tabindex");
              element.setAttribute(
                "data-read-more-tabindex",
                previous === null ? "" : previous
              );
            }
            element.setAttribute("tabindex", "-1");
          }
        });

      if (enabled) {
        clip.removeAttribute("aria-hidden");
      } else {
        clip.setAttribute("aria-hidden", "true");
      }
    }

    function scrollToStart(wrapper) {
      const rect = wrapper.getBoundingClientRect();
      if (rect.top >= 0) return;
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;
      window.scrollTo({
        top: rect.top + window.scrollY - 12,
        behavior: prefersReducedMotion ? "auto" : "smooth",
      });
    }

    document.addEventListener("click", function (event) {
      const button = event.target.closest(".elements-section__read-more-button");
      if (!button) return;

      const wrapper = button.closest("[data-read-more]");
      if (!wrapper) return;

      const clip = wrapper.querySelector(".elements-section__read-more-clip");
      const expanded = wrapper.getAttribute("data-expanded") === "true";
      const nextExpanded = !expanded;

      if (nextExpanded) {
        wrapper.setAttribute("data-expanded", "true");
        button.setAttribute("aria-expanded", "true");
        setFocusable(clip, true);
        updateExpandedHeight(wrapper);
      } else {
        if (clip) {
          clip.style.maxHeight = `${clip.scrollHeight}px`;
        }
        wrapper.setAttribute("data-expanded", "false");
        button.setAttribute("aria-expanded", "false");
        setFocusable(clip, false);
        if (typeof button.focus === "function") {
          button.focus({ preventScroll: true });
        }
        requestAnimationFrame(function () {
          if (clip) {
            clip.style.maxHeight = "";
          }
          scrollToStart(wrapper);
        });
      }
    });

    document
      .querySelectorAll("[data-read-more]")
      .forEach(function (wrapper) {
        const clip = wrapper.querySelector(".elements-section__read-more-clip");
        setFocusable(clip, false);
      });

    window.addEventListener(
      "resize",
      function () {
        document
          .querySelectorAll('[data-read-more][data-expanded="true"]')
          .forEach(function (wrapper) {
            updateExpandedHeight(wrapper);
          });
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll(".faq-section").forEach(function (section) {
      const list = section.querySelector(".faq-list");
      if (!list) return;

      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      function getAnswer(item) {
        return item.querySelector(".faq-answer");
      }

      function openItem(item) {
        const answer = getAnswer(item);
        if (!answer) return;
        item.open = true;
        answer.dataset.state = "opening";

        if (prefersReducedMotion) {
          answer.style.height = "auto";
          answer.style.opacity = "1";
          answer.dataset.state = "open";
          return;
        }

        answer.style.height = "0px";
        answer.style.opacity = "0";
        requestAnimationFrame(function () {
          answer.style.height = `${answer.scrollHeight}px`;
          answer.style.opacity = "1";
        });

        answer.addEventListener(
          "transitionend",
          function onOpenTransition(event) {
            if (event.propertyName !== "height") return;
            answer.removeEventListener("transitionend", onOpenTransition);
            if (answer.dataset.state !== "opening") return;
            answer.style.height = "auto";
            answer.dataset.state = "open";
          }
        );
      }

      function closeItem(item) {
        const answer = item.querySelector(".faq-answer");
        if (!answer) return;

        answer.dataset.state = "closing";

        if (prefersReducedMotion) {
          answer.style.height = "0px";
          answer.style.opacity = "0";
          answer.dataset.state = "closed";
          item.open = false;
          return;
        }

        answer.style.height = `${answer.scrollHeight}px`;
        answer.style.opacity = "1";
        requestAnimationFrame(function () {
          answer.style.height = "0px";
          answer.style.opacity = "0";
        });

        answer.addEventListener(
          "transitionend",
          function onCloseTransition(event) {
            if (event.propertyName !== "height") return;
            answer.removeEventListener("transitionend", onCloseTransition);
            if (answer.dataset.state !== "closing") return;
            answer.dataset.state = "closed";
            item.open = false;
          }
        );
      }

      list.querySelectorAll("details").forEach(function (item) {
        const answer = getAnswer(item);
        if (!answer) return;
        if (item.open) {
          answer.style.height = "auto";
          answer.style.opacity = "1";
          answer.dataset.state = "open";
        } else {
          answer.style.height = "0px";
          answer.style.opacity = "0";
          answer.dataset.state = "closed";
        }
      });

      const openItems = list.querySelectorAll("details[open]");
      if (openItems.length > 1) {
        openItems.forEach(function (item, index) {
          if (index > 0) {
            item.open = false;
            const answer = getAnswer(item);
            if (answer) {
              answer.style.height = "0px";
              answer.style.opacity = "0";
              answer.dataset.state = "closed";
            }
          }
        });
      }

      list.addEventListener("click", function (event) {
        const summary = event.target.closest("summary");
        if (!summary) return;
        const item = summary.parentNode;
        if (!item || item.tagName !== "DETAILS") return;
        event.preventDefault();

        if (item.open) {
          closeItem(item);
          return;
        }

        list.querySelectorAll("details[open]").forEach(function (otherItem) {
          if (otherItem !== item) closeItem(otherItem);
        });

        openItem(item);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.hero-ingredients__carousel');
    
    carousels.forEach(carousel => {
      const wrapper = carousel.closest('.hero-ingredients__carousel-wrapper');
      const prevBtn = wrapper.querySelector('.hero-ingredients__nav--prev');
      const nextBtn = wrapper.querySelector('.hero-ingredients__nav--next');
      
      if(prevBtn && nextBtn) {
        prevBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: -300, behavior: 'smooth' });
        });
        
        nextBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: 300, behavior: 'smooth' });
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-glossary"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const letters = document.querySelectorAll('.ingredients-glossary__letter');
    const cards = document.querySelectorAll('.ingredient-card');
    const emptyState = document.querySelector('.ingredients-glossary__empty-state');

    function filterGrid(letter) {
        let visibleCount = 0;
        cards.forEach(card => {
          // Compare using first letter of dataset-letter (which is already assigned via Liquid)
          if (card.dataset.letter === letter) {
            card.classList.remove('hidden');
            visibleCount++;
          } else {
            card.classList.add('hidden');
          }
        });
        
        if (visibleCount === 0) {
          emptyState.classList.remove('hidden');
        } else {
          emptyState.classList.add('hidden');
        }
    }

    letters.forEach(btn => {
      btn.addEventListener('click', () => {
        letters.forEach(l => l.classList.remove('is-active'));
        btn.classList.add('is-active');
        filterGrid(btn.dataset.filter);
      });
    });
    
    // Check if any cards are visible initially (default A), if not show empty state
    const initialVisible = document.querySelectorAll('.ingredient-card:not(.hidden)').length;
    if (initialVisible === 0) {
       emptyState.classList.remove('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["read-more"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.ReadMoreSection) return;
    window.ReadMoreSection = true;

    const focusableSelector =
      'a[href], button, input, select, textarea, details, [tabindex]';

    function updateExpandedHeight(wrapper) {
      const clip = wrapper.querySelector(".read-more-section__read-more-clip");
      if (!clip) return;
      clip.style.maxHeight = `${clip.scrollHeight}px`;
    }

    function setFocusable(clip, enabled) {
      if (!clip) return;
      clip
        .querySelectorAll(focusableSelector)
        .forEach(function (element) {
          if (enabled) {
            if (element.hasAttribute("data-read-more-tabindex")) {
              const previous = element.getAttribute("data-read-more-tabindex");
              element.removeAttribute("data-read-more-tabindex");
              if (previous === "") {
                element.removeAttribute("tabindex");
              } else {
                element.setAttribute("tabindex", previous);
              }
            }
          } else {
            if (!element.hasAttribute("data-read-more-tabindex")) {
              const previous = element.getAttribute("tabindex");
              element.setAttribute(
                "data-read-more-tabindex",
                previous === null ? "" : previous
              );
            }
            element.setAttribute("tabindex", "-1");
          }
        });

      if (enabled) {
        clip.removeAttribute("aria-hidden");
      } else {
        clip.setAttribute("aria-hidden", "true");
      }
    }

    function scrollToStart(wrapper) {
      const rect = wrapper.getBoundingClientRect();
      if (rect.top >= 0) return;
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;
      window.scrollTo({
        top: rect.top + window.scrollY - 12,
        behavior: prefersReducedMotion ? "auto" : "smooth",
      });
    }

    document.addEventListener("click", function (event) {
      const button = event.target.closest(".read-more-section__read-more-button");
      if (!button) return;

      const wrapper = button.closest("[data-read-more]");
      if (!wrapper) return;

      const clip = wrapper.querySelector(".read-more-section__read-more-clip");
      const expanded = wrapper.getAttribute("data-expanded") === "true";
      const nextExpanded = !expanded;

      if (nextExpanded) {
        wrapper.setAttribute("data-expanded", "true");
        button.setAttribute("aria-expanded", "true");
        setFocusable(clip, true);
        updateExpandedHeight(wrapper);
      } else {
        if (clip) {
          clip.style.maxHeight = `${clip.scrollHeight}px`;
        }
        wrapper.setAttribute("data-expanded", "false");
        button.setAttribute("aria-expanded", "false");
        setFocusable(clip, false);
        if (typeof button.focus === "function") {
          button.focus({ preventScroll: true });
        }
        requestAnimationFrame(function () {
          if (clip) {
            clip.style.maxHeight = "";
          }
          scrollToStart(wrapper);
        });
      }
    });

    document
      .querySelectorAll("[data-read-more]")
      .forEach(function (wrapper) {
        const clip = wrapper.querySelector(".read-more-section__read-more-clip");
        setFocusable(clip, false);
      });

    window.addEventListener(
      "resize",
      function () {
        document
          .querySelectorAll('[data-read-more][data-expanded="true"]')
          .forEach(function (wrapper) {
            updateExpandedHeight(wrapper);
          });
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  function initTestimonialsCarousel(section) {
    var $slider = $(section).find('.testimonials-carousel__slider');
    if (!$slider.length) return;

    var autoplay = $slider.data('autoplay') === true;
    var speed = parseInt($slider.data('speed')) || 5000;
    var $prevArrow = $(section).find('.testimonials-carousel__nav--prev');
    var $nextArrow = $(section).find('.testimonials-carousel__nav--next');

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: autoplay,
      autoplaySpeed: speed,
      arrows: true,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
      dots: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    $('.testimonials-carousel').each(function() {
      initTestimonialsCarousel(this);
    });
  });

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('.testimonials-carousel');
    if (section) initTestimonialsCarousel(section);
  });

  document.addEventListener('shopify:section:unload', function(e) {
    var $slider = $(e.target).find('.testimonials-carousel__slider');
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
